import { IColumns } from '../../../../../../components/Dashboard/TableSmall'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: '',
  columns: [
    {
      id: 'user',
      label: 'USER',
    },
    {
      id: 'gbr',
      label: 'GBR',
      // eslint-disable-next-line
      format: (value: number) => {
        const parts = value.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') // "."  - это раздельтель для разрядов
        return parts.join(',') // ',' - это разделитель для знаков после запятой
      },
    },
    {
      id: 'eur',
      label: 'EUR',
      // eslint-disable-next-line
      format: (value: number) => {
        const parts = value.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') // "."  - это раздельтель для разрядов
        return parts.join(',') // ',' - это разделитель для знаков после запятой
      },
    },
    {
      id: 'btc',
      label: 'BTC',
      // eslint-disable-next-line
      format: (value: number) => {
        const parts = value.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') // "."  - это раздельтель для разрядов
        return parts.join(',') // ',' - это разделитель для знаков после запятой
      },
    },
    {
      id: 'oneButton',
      label: '',
    },
  ],
}

export const stateData = [
  // { id: 1, user: 'Elnora Edwards', gbr: 1000000, eur: 1000000, btc: 10000 },
  // { id: 2, user: 'Annie Davis', gbr: 1000000, eur: 1000000, btc: 10000 },
  // { id: 3, user: 'Rebecca McGee', gbr: 1000000, eur: 1000000, btc: 10000 },
  // { id: 4, user: 'Florence Ross', gbr: 1000000, eur: 1000000, btc: 10000 },
  // { id: 5, user: 'Clara Mills', gbr: 1000000, eur: 1000000, btc: 10000 },
  // { id: '', user: '', gbr: '', eur: '', btc: '' },
]
